import React from 'react';
import BoxNumberSearch from './BoxNumberSearch';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

function InstalationPage() {
    const theme = useTheme();
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column',   p: 4 }}>
            <BoxNumberSearch />
            <Typography variant="h4" component="h1" gutterBottom sx={{  p: 1, display: 'inline-block' }}>
                Instalation Page
            </Typography>
            
        </Box>
    );
}

export default InstalationPage;
